import React, { FC } from "react"
import { NextPageCb } from "~/hooks/useNextQuiz"
import { Box, Flex, Image, Text } from "@chakra-ui/react"
import {
  NextButton,
  NextButtonBottomSlideUpContainer as NextButtonContainer,
} from "~/components/shared/NextButton"
import { StarIcon } from "~/components/pages/ReviewPage/Icons"
import { TT, TTString } from "~/components/shared/AttributedString"
import { BasePageWrapper } from "~/components/shared/BasePageWrapper/BasePageWrapper"
import { BasePageHeader } from "~/components/shared/BasePageHeader/BasePageHeader"
import { useIsLoviTheme } from "~/theme/themeProvider"

export const ReviewPage: FC<{
  title: TTString
  author: TTString
  date: TTString
  text: TTString
  image: string
  next: NextPageCb
}> = ({ title, image, next: onNext, author, date, text }) => {
  const isLoviTheme = useIsLoviTheme()
  return (
    <BasePageWrapper>
      <BasePageHeader textAlign={isLoviTheme ? "left" : "center"} title={title} />
      <Image mt={5} src={image} />
      <Box mt={6}>
        <Flex gap={0.5} mb={4}>
          <StarIcon />
          <StarIcon />
          <StarIcon />
          <StarIcon />
          <StarIcon />
        </Flex>
        <Flex mb={2} gap={0.5} justifyContent="space-between" alignItems="center">
          <Box textStyle="MediumSubtitlePrimary">
            <TT>{author}</TT>
          </Box>
          <Box textStyle="RegularParagraphSecondary" textColor="Base/baseSecondary">
            <TT>{date}</TT>
          </Box>
        </Flex>
        <Text textStyle="RegularParagraphSecondary">
          <TT>{text}</TT>
        </Text>
      </Box>
      <NextButtonContainer visible>
        <NextButton onClick={onNext} />
      </NextButtonContainer>
    </BasePageWrapper>
  )
}
